import { Component } from "react";
// import AuthSpinHandler from "./AuthSpinHandler";

// must extend AuthSpinHandler to disable the inputs and buttons on form submission

export default class AuthFlowBase extends Component {
  constructor(constructorProps) {
    super();
    this.state = {};
  }

  onSuccess() {
    this.props.history.push("/");
  }

  onSignIn() {
    this.props.authAdapterFactory.authAdapter.onSpin(true);
    this.props.authAdapterFactory.authAdapter
      ._syncData()
      .then(() => this.props.authAdapterFactory.authAdapter.onSpin(false));
  }

  onSignOut() {
    window.wipeData();
  }

  handleValidationError(error) {
    this.setState({ validationErrors: error.message.split("\n") });
  }

  clearValidationErrors() {
    this.setState({ validationErrors: [] });
  }

  get baseProps() {
    return {
      isSpinning: this.state.isSpinning,
      validationErrors: this.state.validationErrors,
    };
  }
}



// WEBPACK FOOTER //
// ./src/auth/lib/AuthFlowBase.js